import { urls } from "../api/api.urls";
import makeRequest from "../api/make.request";

export default class RequestService {
    static async getLogs() {
        return makeRequest(urls.request.getLogs, "get");
    }
}